export const TABLE_NAME = {
  ACCOUNTS: 'Accounts',
  ACCOUNTS_BY_USER: 'Accounts By User',
  CLIENT_SETUP: 'Client Setup',
  USERS_FOR_ACCOUNT: 'Users For Accounts',
  FILE_MAPPING_FORMAT: 'File Mapping Formats',
  FILE_MAPPING_FORMAT_BY_CLIENT: 'File Mapping Formats By Client',
  USER_ROLE: 'User Role',
  BANK_USER_SETUP: 'Bank User Setup',
  CLIENT_USER_SETUP: 'Client User Setup',
  HELP_PAGE: 'Help Page',
  VIEW_VERSION_HISTORY: 'View Version History',
  ISSUED_CHECK_LOG_RESULTS: 'Check File Upload History Results',
  PAYEE_MATCH_PARAMETERS: 'Payee Match Parameters',
  ACH_EXCEPTION_RULE: 'ACH Exception Rules',
  BATCH_PROCESSING: 'Batch Processing Log',
  VIEW_AUDIT_HISTORY: 'View Audit History',

  ALL_TRANSACTION_RESULTS: 'All Transactions Results',
  ALL_TRANSACTION_RESULTS_ACH: 'All Transactions Results - ACH',
  ALL_TRANSACTION_RESULTS_CHECKS: 'All Transactions Results - Checks',
  ALL_TRANSACTION_RESULTS_VOIDS: 'All Transactions Results - Voids',
  ALL_TRANSACTION_RESULTS_STALE_DATED: 'All Transactions Results - Stale Dated',
  ALL_TRANSACTION_RESULTS_PAYEE_MATCH: 'All Transactions Results - Payee Match',
  ALL_TRANSACTION_RESULTS_ISSUED: 'All Transactions Results - Issued',
  VOID_CHECKS_RESULTS: 'Issued Check List',
  ISSUED_CHECK_LOG_TABLE: 'Check File Upload History',
  SENT_EMAIL_TEXTS_RESULTS: 'Sent Email/Texts Results',
  AUDIT_TRAIL_LOG: 'Audit Trail Log',
  QUICK_EXCEPTION_PROCESSING_ACH: 'Quick Exception Processing - ACH',
  QUICK_EXCEPTION_PROCESSING_CHECK: 'Quick Exception Processing - Checks',
  DATA_IMPORT_PROCESSING: 'Data Import Processing',
  EXCEPTION_ITEMS_RESULTS: 'Exception Items Results',
  ERROR_DETAILS: 'Error Details',
}
